import * as React from 'react';
import Alert, { AlertCategoryEnum } from '../../../misc/components/Alert';
import Select from 'react-select';
import { CoughAnalysisSet } from 'webportalclient';
import { DateTimeAccuracy, FormatTime, LocalizedDateTime } from '../../../misc/components/LocalizedDateTime';

export interface SelectPrimaryAnalysisSetFormProps {
    showError: boolean;
    analysisSetOptions: Array<CoughAnalysisSet>;
    selectedAnalysisSets: Array<CoughAnalysisSet>;
    onSubmit: () => void;
    onChange: (values) => void;
    onClose: () => void;
}

export const SelectPrimaryAnalysisSetForm = (props: SelectPrimaryAnalysisSetFormProps) => {
    return (
        <>
            <div className='modal-body'>
                <div className='row'>
                    <div className='col-md-12 form-group'>
                        <Alert show={props.showError} category={AlertCategoryEnum.Danger}>
                            At least one analysis set selection is required
                        </Alert>
                        <label>Primary Analysis Sets</label>
                        <Select
                            classNamePrefix="PrimaryAnalysisSets"
                            options={props.analysisSetOptions}
                            value={props.selectedAnalysisSets}
                            getOptionValue={o => o.id}
                            getOptionLabel={o => `${o.typeName} - ${FormatTime(o.created, DateTimeAccuracy.Minute, false)} (${o.statusName})`}
                            isMulti={true}
                            onChange={(v) => props.onChange(v)}
                        />
                    </div>
                </div>
            </div>
            <div className='modal-footer'>
                <button className='btn btn-primary' onClick={() => props.onSubmit()}>
                    Set Primary
                </button>
                <button className='btn btn-primary btn-outline' onClick={() => props.onClose()}>
                    Close
                </button>
            </div>
        </>            
    );
}
